import { Component, OnInit } from '@angular/core';
import { GbgIdentityVerification, GbgIdentityVerificationQuery, GbgIdentityVerificationService, MemberQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-gbg-identity-status',
  templateUrl: './gbg-identity-status.component.html',
  styleUrls: ['./gbg-identity-status.component.scss'],
})
export class GbgIdentityStatusComponent implements OnInit {
  identityVerified$: Observable<GbgIdentityVerification | undefined>;
  memberId = '';
  constructor(
    private gbgVerificationQuery: GbgIdentityVerificationQuery,
    private gbgVerificationService: GbgIdentityVerificationService,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit() {
    this.memberId = this.memberQuery.getUserContext().memberId;
    this.gbgVerificationService.fetchVerificationStatus(this.memberId).toPromise();
    this.identityVerified$ = this.gbgVerificationQuery.selectFirst();
  }

  ssoToGbg() {
    this.gbgVerificationService.generateGbgSso(this.memberId).toPromise();
  }
}
